import { Injectable } from '@angular/core';

@Injectable()
export class StringUtilService {
	static isEmpty(value: string): boolean {
		return !value || 0 === value.length || !value.trim();
	}

	static isNotEmpty(value: string): boolean {
		return !StringUtilService.isEmpty(value);
	}
}
